import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { ResizeObservable } from "@webapp/shared/utils/utils";
import { CHIP_HEIGHT, MARGIN_SIZE, getViewMoreButtonWidth } from "../utils/utils";

@Component({
  selector: "view-more",
  templateUrl: "view-more.component.html",
  styleUrls: ["view-more.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
})
export class ViewMoreComponent implements AfterViewInit {
  @ViewChild("content", { static: false }) public content: ElementRef<HTMLDivElement>;

  @Input() public numberOfElements: number;
  public viewMoreButtonOrder: number;
  public isOverflowing: boolean;
  public isExpanded = false;

  private viewMoreButtonWidth;

  constructor(private destroyService$: DestroyService, private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    const home = document.querySelector("#home") as HTMLElement;
    this.viewMoreButtonWidth = getViewMoreButtonWidth();

    new ResizeObservable(home).pipe(debounceTime(200), distinctUntilChanged(), takeUntil(this.destroyService$)).subscribe(() => {
      this.checkOverflow();
    });
  }

  private checkOverflow(): void {
    if (this.content.nativeElement.scrollHeight > CHIP_HEIGHT) {
      this.isOverflowing = true;
      this.calculateIndexToBeInsertedAt();
      this.cdr.detectChanges();
    } else {
      this.isOverflowing = false;
      this.cdr.detectChanges();
    }
  }

  private calculateIndexToBeInsertedAt(): void {
    const container = this.content.nativeElement;
    const children = container.children;
    const totalWidth = this.getTotalWidth(children);
    const availableWidth = container.offsetWidth - this.viewMoreButtonWidth;

    if (totalWidth <= availableWidth) {
      this.viewMoreButtonOrder = children.length - 1;
    } else {
      this.viewMoreButtonOrder = this.getInsertionIndex(children, availableWidth) - 1;
    }
  }

  private getTotalWidth(children: HTMLCollection): number {
    let totalWidth = 0;
    for (let i = 0; i < children.length; i++) {
      const childWidth = (children[i] as HTMLElement).offsetWidth + MARGIN_SIZE;
      totalWidth += childWidth;
    }
    return totalWidth;
  }

  private getInsertionIndex(children: HTMLCollection, availableWidth: number): number {
    let totalWidth = 0;
    for (let i = 0; i < children.length; i++) {
      const childWidth = (children[i] as HTMLElement).offsetWidth + MARGIN_SIZE;
      if (totalWidth + childWidth > availableWidth) {
        if (totalWidth + MARGIN_SIZE < availableWidth) {
          return i;
        } else {
          return i - 1;
        }
      }
      totalWidth += childWidth;
    }
    return children.length - 1;
  }

  public toggleContent(): void {
    this.isExpanded = !this.isExpanded;
    this.cdr.detectChanges();
  }
}
